export const classNames = (...classes) => classes.filter((c) => !!c).join(' ');
export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
